import { APIURL } from "./config";

export const postTag = async (
  tagName: string | undefined,
  rankTypeId: string | undefined,
  view: string,
  isCompany: boolean,
  token: string
) => {
  try {
    if (tagName !== undefined) {
      const response = await fetch(`${APIURL}/Tag?rankTypeId=${rankTypeId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          name: tagName,
          isCompany,
          view
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return {
          error: true,
          message: errorData.message || "Failed to create tag",
        };
      }

      return {
        error: false,
      };
    }
  } catch (ex) {
    console.log(ex);
  }
  return;
};

export const getTags = async (rankTypeId: string | undefined, isCompany: boolean, view: string, token: string) => {
  let json;
  try {
    let res;
    if (rankTypeId === undefined) return;
    if (isCompany) {
      res = await fetch(`${APIURL}/Tag/Company?rankTypeId=${rankTypeId}&view=${view}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } else {
      res = await fetch(`${APIURL}/Tag/University?rankTypeId=${rankTypeId}&view=${view}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
    json = await res.json();
  } catch (ex) {
    console.log(ex);
  }

  return json;
};

export const deleteTag = async (tagId: any, token: string) => {
  try {
    const response = await fetch(`${APIURL}/Tag/${tagId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      return {
        error: true,
        message: errorData.message || "Failed to delete tag",
      };
    }

    return { error: false };
  } catch (ex) {
    console.log(ex);
  }
};

export const assignTagCompanies = async (
  tagIds: string[],
  companyIds: string[],
  token: string
) => {
  try {
    const response = await fetch(`${APIURL}/Tag/Company/Assign`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        tagIds,
        companyIds,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      return {
        error: true,
        message: errorData.message || "Failed to assign tag",
      };
    }

    return { error: false };
  } catch (ex) {
    console.error(ex);
  }
};

export const assignTagUniversities = async (
  tagIds: string[],
  universityIds: string[],
  token: string
) => {
  try {
    const response = await fetch(`${APIURL}/Tag/University/Assign`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        tagIds,
        universityIds,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      return {
        error: true,
        message: errorData.message || "Failed to assign tag",
      };
    }

    return { error: false };
  } catch (ex) {
    console.error(ex);
  }
};

export const deallocateTag = async (
  entityId: string,
  tagId: string,
  isCompany: boolean,
  view: string,
  token: string
) => {
  try {
    if (isCompany) {
      await fetch(
        `${APIURL}/Tag/Company/Remove?companyId=${entityId}&tagId=${tagId}&view=${view}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } else {
      await fetch(
        `${APIURL}/Tag/University/Remove?universityId=${entityId}&tagId=${tagId}&view=${view}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    }
  } catch (ex) {
    console.log(ex);
  }
};

export const editTag = async (Id: string, name: string, token: string) => {
  try {
    const res = await fetch(`${APIURL}/Tag/Edit`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        Id,
        name,
      }),
    });

    const data = await res.json();
    if (!res.ok) {
      return {
        error: true,
        message: data.message || "Failed to edit the tag."
      };
    }
    return {
      error: false,
      item: data,
    };
  } catch (ex) { }
};

export const PostSubtag = async (tagId: string, subtagName: string, token: string) => {
  try {
    const res = await fetch(`${APIURL}/Tag/Subtag`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ tagId, subtagName: subtagName }),
    });

    if (!res.ok) {
      const errorData = await res.json();
      return {
        error: true,
        message: errorData.message || "Failed to create subtag.",
      };
    }

    return { error: false };
  } catch (err) {
    console.log(err);
  }
};

export const AssignCompanySubtags = async (
  tagSubtagIds: string[],
  companyIds: string[],
  token: string
) => {
  try {
    const res = await fetch(`${APIURL}/Tag/Subtag/Assign/Company`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        tagSubtagIds,
        companyIds,
      }),
    });

    if (!res.ok) {
      const errorData = await res.json();
      return {
        error: true,
        message: errorData.message || "Failed to assign Subtags.",
      };
    }

    return {
      error: false,
    };
  } catch (ex) {
    console.log(ex);
  }
};

export const AssignUniversitySubtags = async (
  tagSubtagIds: string[],
  universityIds: string[],
  token: string
) => {
  try {
    const res = await fetch(`${APIURL}/Tag/Subtag/Assign/University`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        tagSubtagIds,
        universityIds,
      }),
    });

    if (!res.ok) {
      const errorData = await res.json();
      return {
        error: true,
        message: errorData.message || "Failed to assign Subtags.",
      };
    }

    return {
      error: false,
    };
  } catch (ex) {
    console.log(ex);
  }
};

export const deleteSubtag = async (tagId: string, subtagId: string, token: string) => {
  try {
    const res = await fetch(`${APIURL}/Tag/Subtag/${tagId}/${subtagId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      const errorData = await res.json();
      return {
        error: true,
        message: errorData.message || "Failed to delete the subtag",
      };
    }

    return {
      error: false,
    };
  } catch (ex) {
    console.log(ex);
  }
};

export const editSubtag = async (subtagId: string, name: string, token: string) => {
  try {
    const res = await fetch(`${APIURL}/Tag/Subtag/${subtagId}`, {
      method: "PUT",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ name }),
    });
    const data = await res.json();
    if (!res.ok) {
      return {
        error: true,
        message: data.message || "Failed to edit the subtag.",
      };
    }

    return {
      error: false,
      item: data,
    };
  } catch (ex) {
    console.log(ex);
  }
};

export const deallocateSubtag = async (
  entityId: string,
  tagSubtagId: string,
  isCompany: boolean,
  view: string,
  token: string
) => {
  try {
    if (isCompany) {
      await fetch(
        `${APIURL}/Tag/TagSubtag/Company/Remove?companyId=${entityId}&tagSubtagId=${tagSubtagId}&view=${view}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } else {
      await fetch(
        `${APIURL}/Tag/TagSubtag/University/Remove?universityId=${entityId}&tagSubtagId=${tagSubtagId}&view=${view}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    }
  } catch (ex) {
    console.log(ex);
  }
};
